import Chip, { ChipColor } from 'web-common/src/shared/design-system/components/Chip';

const NewShefChip = () => <Chip fontWeight='bold' color={ChipColor.SOURDOUGH} copy='NEW!' />;

export default NewShefChip;
